<template>
  <div align="center" style="width: 70vw; margin: 40px auto 10px;">
    <!-- <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn color="primary float" fab bottom right fixed @click="openCreate" v-on="on">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Add</span>
    </v-tooltip>-->

    <div class="mx-10" v-if="allLocations.length">
      <!-- <v-layout row wrap justify-center>
        <v-btn
          fab
          x-small
          class="mx-2"
          @click="fetchPagedDevicesListBack()"
          :disabled="query.page === 1"
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-btn
          v-for="i in allLocations.total_pages"
          :key="i"
          fab
          x-small
          class="mx-2"
          :class="{primary: query.page === i}"
          @click="fetchPagedDevicesList(i)"
        >{{i}}</v-btn>
        <v-btn
          fab
          x-small
          class="mx-2"
          @click="fetchPagedDevicesListForward() "
          :disabled="query.page === allLocations.total_pages"
        >
          <v-icon>arrow_forward</v-icon>
        </v-btn>
      </v-layout>-->
      <v-pagination v-model="query.page" :length="pageCount" circle></v-pagination>
      <v-card-title>
        <v-text-field
          hide-details
          append-icon="search"
          placeholder="Search"
          v-model="search"
          clearable
        ></v-text-field>
      </v-card-title>
      <div v-if="allLocations.length">
        <v-data-table
          :headers="headers"
          :items="allLocations"
          :search="search"
          :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50]
      }"
          :items-per-page="query.limit"
          :page.sync="query.page"
          @page-count="pageCount = $event"
          hide-default-footer
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item,index) in items" :key="index">
                <td class="text-left">{{item.name}}</td>
                <td class="text-center">{{item.display_name}}</td>
                <td class="text-right">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        fab
                        depressed
                        x-small
                        class="text--white mx-8"
                        @click="openViewLocationDialog(item)"
                      >
                        <v-icon v-on="on">visibility</v-icon>
                      </v-btn>
                    </template>
                    <span>View Details</span>
                  </v-tooltip>
                  <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        fab
                        x-small
                        class="text--white mx-1"
                        @click="openUpdate(item)"
                      >
                        <v-icon v-on="on">edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        fab
                        x-small
                        class="mx-1"
                        @click="openAssociateDeviceModel(item)"
                      >
                        <v-icon color v-on="on">devices</v-icon>
                      </v-btn>
                    </template>
                    <span>Associate Device</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        fab
                        x-small
                        class="mx-1"
                        @click="openAddUsersModel(item)"
                      >
                        <v-icon color v-on="on">add</v-icon>
                      </v-btn>
                    </template>
                    <span>Add Users to this location</span>
                  </v-tooltip>-->
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <v-pagination
          v-model="query.page"
          :length="pageCount"
          circle
          v-if="allLocations.length > 20"
          class="my-4"
        ></v-pagination>
      </div>
    </div>
    <div v-else>No locations found.</div>
    <v-dialog v-model="createDialog" scrollable persistent :width="900" @keydown.esc="cancelCreate">
      <v-card>
        <v-card-title class="primary text-white">
          Create Location
          <v-spacer></v-spacer>
          <v-icon dark @click="cancelCreate">close</v-icon>
        </v-card-title>

        <v-card-text class="pa-8">
          <div ref="createForm">
            <v-form v-if="step === 1" ref="step1" @submit.prevent>
              <v-text-field
                label="Name"
                v-model="name"
                :rules="rules"
                @input="editName()"
                @keyup.enter="submitFirstStep"
              ></v-text-field>
              <v-text-field
                label="Display Name"
                v-model="displayName"
                @keyup.enter="submitFirstStep"
              ></v-text-field>
              <v-text-field label="Slug" v-model="slug" @keyup.enter="submitFirstStep"></v-text-field>
              <v-text-field
                label="Internal Id"
                v-model="internal_id"
                @keyup.enter="submitFirstStep"
              ></v-text-field>
            </v-form>
            <transition name="slide-fade">
              <v-form v-if="step === 2" ref="step2" @submit.prevent>
                <v-text-field
                  @keyup.enter="comfirmCreate"
                  label="Address"
                  v-model="address"
                  :rules="rules"
                ></v-text-field>
                <v-text-field @keyup.enter="comfirmCreate" label="Suite / Unit" v-model="unit"></v-text-field>
                <v-text-field
                  @keyup.enter="comfirmCreate"
                  label="City"
                  v-model="city"
                  :rules="rules"
                ></v-text-field>
                <!-- <v-text-field label="State" <v-autocomplete label="State" :items="states"></v-autocomplete> :rules="rules"></v-text-field> -->

                <v-row>
                  <v-col cols="6">
                    <!-- <v-autocomplete label="State" :items="states"></v-autocomplete> -->
                    <v-text-field
                      @keyup.enter="comfirmCreate"
                      label="State / Province"
                      v-model="state"
                      :rules="rules"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <!-- <v-autocomplete label="State" :items="states"></v-autocomplete> -->
                    <v-text-field @keyup.enter="comfirmCreate" label="Postal Code" v-model="postal"></v-text-field>
                  </v-col>
                </v-row>
                <v-autocomplete
                  @keyup.enter="comfirmCreate"
                  label="Country"
                  :items="countries"
                  v-model="country"
                  :rules="rules"
                ></v-autocomplete>
              </v-form>
            </transition>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="error" text @click="cancelCreate">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text v-if="step === 1" @click="submitFirstStep">Add Address</v-btn>
          <v-btn color="success" text v-if="step === 2" @click="comfirmCreate">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="updateDialog" scrollable persistent :width="900" @keydown.esc="cancelUpdate">
      <v-card>
        <v-card-title class="primary text-white">
          Update "{{selectedLocation.name}}"
          <v-spacer></v-spacer>
          <v-icon dark @click="cancelUpdate">close</v-icon>
        </v-card-title>

        <v-card-text class="pa-8">
          <div>
            <v-form ref="updateForm" @submit.prevent>
              <v-text-field label="Name" v-model="name" :rules="rules">
                <!-- @input="editName()" -->
              </v-text-field>
              <v-text-field label="Display Name" v-model="displayName"></v-text-field>
              <v-text-field readonly label="Slug" v-model="slug"></v-text-field>
              <v-text-field readonly label="Internal Id" v-model="internal_id"></v-text-field>
              <v-text-field readonly label="Address" v-model="address"></v-text-field>
              <v-text-field readonly label="Suite / Unit" v-model="unit"></v-text-field>
              <v-text-field readonly label="City" v-model="city"></v-text-field>
              <!-- <v-text-field label="State" <v-autocomplete label="State" :items="states"></v-autocomplete>></v-text-field> -->

              <v-row>
                <v-col cols="6">
                  <v-text-field readonly label="State / Province" v-model="state"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field readonly label="Postal Code" v-model="postal"></v-text-field>
                </v-col>
              </v-row>
              <!-- <v-autocomplete label="Country" :items="countries" v-model="country" :rules="rules"></v-autocomplete> -->
              <v-text-field readonly label="Country" v-model="country"></v-text-field>
            </v-form>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="error" text @click="deleteLocationWarning = true">Delete</v-btn>
          <v-spacer></v-spacer>
          <!-- <v-btn color="error" text >Cancel</v-btn> -->
          <v-btn color="success" text @click="comfirmUpdate">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteLocationWarning" :width="400">
      <v-card>
        <v-card-title class="primary text-white">
          Delete?
          <v-spacer></v-spacer>
          <v-icon dark @click="deleteLocationWarning = false">close</v-icon>
        </v-card-title>
        <v-card-text class="text-center">
          <v-icon size="60" color="warning" class="mt-7 mb-3">warning</v-icon>
          <div>Are you sure you want to delete this location?</div>
          <div class="mt-4">
            <v-btn text color="error" @click="deleteLocationWarning = false">No</v-btn>
            <v-btn text color="success" @click="deleteLocation()">Yes</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="associateDeviceModel"
      scrollable
      persistent
      :width="900"
      @keydown.esc="associateDeviceModel = false"
    >
      <v-card :min-height="200">
        <v-card-title class="primary text-white">
          Select the Device Type
          <v-spacer></v-spacer>

          <v-icon dark @click="associateDeviceModel = false">close</v-icon>
        </v-card-title>
        <v-card-text class="pa-7 text-center">
          <v-btn color class="mr-7">Signage Unit</v-btn>
          <v-btn color>Wifi Tracker</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" text @click="associateDeviceModel = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click>Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Users Modal -->
    <v-dialog
      v-model="addUsersModel"
      scrollable
      persistent
      :width="600"
      @keydown.esc="cancelAddUsersModel"
    >
      <v-card :min-height="200">
        <v-card-title class="primary text-white">
          Add Users to {{selectedLocation.name}}
          <v-spacer></v-spacer>

          <v-icon dark @click="cancelAddUsersModel">close</v-icon>
        </v-card-title>
        <v-card-text class="pa-0 text-center">
          <v-list class="grey lighten-4 py-0">
            <v-list-item-group v-model="addUsers" color="success" multiple>
              <v-divider></v-divider>

              <div v-for="(user, index) in users" :key="user.id">
                <v-list-item @click="selectUser(user)">
                  <v-list-item-content>
                    <v-list-item-title>{{index+1}}. {{user.first_name.toUpperCase()}} {{user.last_name.toUpperCase()}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
              </div>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="error" text @click="cancelAddUsersModel">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="confirmAddUser">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="viewLocationsDialog"
      scrollable
      persistent
      :width="900"
      @keydown.esc="viewLocationsDialog = false"
    >
      <v-card>
        <v-card-title class="primary text-white">
          {{selectedLocation.name}}
          <v-spacer></v-spacer>
          <v-icon dark @click="viewLocationsDialog = false">close</v-icon>
        </v-card-title>

        <v-card-text class="pa-8">
          <div>
            <v-form>
              <v-text-field readonly label="Name" v-model="selectedLocation.name" :rules="rules">
                <!-- @input="editName()" -->
              </v-text-field>
              <v-text-field readonly label="Display Name" v-model="selectedLocation.display_name"></v-text-field>
              <v-text-field readonly label="Slug" v-model="selectedLocation.slug"></v-text-field>
              <v-text-field readonly label="Internal Id" v-model="selectedLocation.internal_id"></v-text-field>
              <template v-if="selectedLocation.address">
                <v-text-field
                  readonly
                  label="Address"
                  v-model="selectedLocation.address.address_line_1"
                ></v-text-field>
                <v-text-field
                  readonly
                  label="Suite / Unit"
                  v-model="selectedLocation.address.address_line_2"
                ></v-text-field>
                <v-text-field readonly label="City" v-model="selectedLocation.address.city"></v-text-field>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      readonly
                      label="State / Province"
                      v-model="selectedLocation.address.province"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      readonly
                      label="Postal Code"
                      v-model="selectedLocation.address.postal_code"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-text-field readonly label="Country" v-model="selectedLocation.address.country"></v-text-field>
              </template>
            </v-form>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" text @click="viewLocationsDialog = false">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import countries from '@/assets/countries.js'
import { mapGetters, mapActions } from 'vuex'

function initialState () {
  return {
    displayAll: false,
    step: 1,
    createDialog: false,
    updateDialog: false,
    deleteLocationWarning: false,
    associateDeviceModel: false,
    addUsersModel: false,
    viewLocationsDialog: false,
    name: '',
    DisplayName: '',
    slug: '',
    internal_id: '',
    address: '',
    unit: '',
    city: '',
    state: '',
    postal: '',
    states: [
      'Alberta',
      'British Columbia',
      'Manitoba',
      'New Brunswick',
      'Newfoundland and Labrador',
      'Northwest Territories',
      'Nova Scotia',
      'Nunavut',
      'Ontario',
      'Prince Edward Island',
      'Quebec',
      'Saskatchewan',
      'Yukon'
    ],
    country: '',
    rules: [v => !!v || 'Required'],
    headers: [
      {
        text: 'Location Name',
        value: 'name',
        class: '',
        width: '20%'
      },
      {
        text: 'Display Name',
        value: 'name',
        align: 'center'
      },
      {
        text: 'Actions',
        sortable: false,
        align: 'right',
        class: 'pr-12'
      }
    ],
    search: '',
    selectedLocation: '',
    addUsers: [],
    selectedUsers: [],
    query: {
      limit: 50,
      page: 1,
      withAddress: true,
      withContactDetails: true
    },
    pageCount: 0,
    currentPage: 1
  }
}
export default {
  data () {
    return initialState()
  },
  computed: {
    displayName: {
      get () {
        if (this.DisplayName) {
          return this.DisplayName
        }
        return ''
      },
      set (val) {
        this.DisplayName = val
      }
    },
    countries () {
      return countries
    },
    ...mapGetters({
      allLocations: 'locations/allLocations',
      locationAddress: 'locations/locationAddress',
      users: 'locations/users'
    })
  },
  async mounted () {
    this.spinner(true)
    try {
      await this.$store.dispatch('locations/GetAllLocations', this.query)
      this.displayAll = true
    } catch (e) {
      this.snackbar({ text: e.response.data.msg })
    }
    this.spinner(false)
  },
  methods: {
    // Open modal to create a location
    openCreate () {
      this.createDialog = true
      this.step = 1
    },

    // Close modal to create a location
    cancelCreate () {
      this.createDialog = false
      if (this.step === 1) {
        this.$refs.step1.resetValidation()
      }
      if (this.step === 2) {
        this.$refs.step2.resetValidation()
      }
      this.resetAll()
    },

    // Create a Location with Name (required)
    async submitFirstStep () {
      if (this.$refs.step1.validate()) {
        const data = {
          name: this.name,
          display_name: this.displayName,
          slug: this.slug,
          internal_id: this.internal_id
        }
        try {
          // Creating a location
          await this.$store.dispatch('locations/CreateLocations', data)
          // fetching all locations for updating the page
          await this.$store.dispatch('locations/GetAllLocations', this.query)
          this.step = 2
          this.snackbar({ text: 'Successfully created location' })
        } catch (e) {
          this.snackbar({ text: 'Failed' })
        }
      }
    },

    // After Creating the location, add location to the address
    async comfirmCreate () {
      this.spinner(true)
      if (this.$refs.step2.validate()) {
        await this.addLocationAddress()
      }
      this.spinner(false)
    },

    async addLocationAddress () {
      const data = {
        address_line_1: this.address,
        address_line_2: this.unit,
        city: this.city,
        province: this.state,
        country: this.country,
        postal_code: this.postal
      }
      try {
        // add address to the location
        await this.$store.dispatch('locations/AddAddressToLocation', data)
        // fetching all locations for updating the page
        await this.$store.dispatch('locations/GetAllLocations', this.query)

        this.step = 2
        this.snackbar({ text: 'Successfully added address' })
        this.spinner(false)

        this.createDialog = false
      } catch (e) {
        this.snackbar({ text: e.response.data.msg })
      }
    },

    // Open modal to update the location
    async openUpdate (location) {
      // Fill the values in the field with the value of Selected location
      this.selectedLocation = location
      this.name = location.name
      this.DisplayName = location.display_name
      this.slug = location.slug
      this.internal_id = location.internal_id
      this.updateDialog = true
      await this.$store.commit('locations/SET_LOCATION', location)
      try {
        await this.getAddress()
        this.address = this.locationAddress.address_line_1
        this.unit = this.locationAddress.address_line_2
        this.city = this.locationAddress.city
        this.state = this.locationAddress.province
        this.postal = this.locationAddress.postal_code
        this.country =
          this.locationAddress.country === 'CA'
            ? 'Canada'
            : this.locationAddress.country
      } catch (e) {
        this.snackbar({ text: e.response.data.msg })
        this.address = ''
        this.unit = ''
        this.city = ''
        this.state = ''
        this.postal = ''
        this.states = ''
      }
    },

    // When user changes the value in Name field, changing the display name also
    editName () {
      this.DisplayName = this.name
    },

    // Cancel and close the update modal
    cancelUpdate () {
      this.updateDialog = false
      this.$refs.updateForm.resetValidation()
      this.resetAll()
    },

    // Confirm the update
    async comfirmUpdate () {
      if (this.$refs.updateForm.validate()) {
        try {
          let data = {
            name: this.name,
            display_name: this.DisplayName,
            slug: this.slug,
            internal_id: this.internal_id,
            is_corporate: false
          }
          let id = this.selectedLocation.id
          await this.$store.dispatch('locations/UpdateLocation', { data, id })
          // check if the names fields are different or not

          // check if the address fields are different or not
          // if it was empty then add otherwise update

          // let address = {}
          // if (this.selectedLocation.address) Object.assign(address, this.selectedLocation.address)

          this.snackbar({ text: 'Successfully Updated' })
          this.resetAll()
        } catch (e) {
          this.snackbar({ text: e.response.data.msg })
        }
      }
    },

    async deleteLocation () {
      this.spinner(true)
      let locationId = this.selectedLocation.id
      try {
        await this.$store.dispatch('locations/DeleteLocation', { locationId })
        this.$refs.updateForm.resetValidation()
        let index = this.allLocations.findIndex(el => el.id.match(locationId))
        this.allLocations.splice(index, 1)
        this.resetAll()
        this.snackbar({ text: 'Successfully deleted' })
      } catch (e) {
        this.snackbar({ text: e.response.data.msg })
      }
      this.spinner(false)
    },

    // Open the modal for associate devices
    openAssociateDeviceModel () {
      this.associateDeviceModel = true
    },
    openAddUsersModel (location) {
      this.selectedLocation = location
      this.$store.dispatch('locations/GetUsersOfBusiness')
      this.addUsersModel = true
    },
    cancelAddUsersModel () {
      this.resetAll()
    },
    selectUser (user) {
      const duplicate = this.selectedUsers.find(el => el.uuid.match(user.uuid))
      if (duplicate) {
        // this will find the index of the duplicate and delete
        const indexDuplicate = this.selectedUsers.findIndex(
          el => el.uuid === duplicate.uuid
        )
        this.selectedUsers.splice(indexDuplicate, 1)
      } else {
        this.selectedUsers.push(user)
      }
    },
    async confirmAddUser () {
      this.spinner(true)
      const value = {
        locationId: this.selectedLocation.id,
        data: {
          user_ids: this.selectedUsers.map(el => el.uuid)
        }
      }
      try {
        await this.$store.dispatch('locations/AddUsersToLocation', value)
        this.snackbar({ text: 'Successfully added users to the location' })
        this.spinner(false)
        this.resetAll()
      } catch (e) {
        this.snackbar({ text: e.response.data.msg })
        this.spinner(false)
      }
      // this.spinner(true)
    },

    // Fetch paged locations
    async fetchPagedDevicesList (page) {
      this.spinner(true)
      this.query.page = page
      if (page !== this.allLocations.current_page) {
        await this.$store.dispatch('locations/GetAllLocations', this.query)
      }
      this.spinner(false)
    },

    async fetchPagedDevicesListBack (page) {
      this.spinner(true)
      if (this.query.page > 1) {
        this.query.page--
        await this.$store.dispatch('locations/GetAllLocations', this.query)
      }
      this.spinner(false)
    },
    async fetchPagedDevicesListForward (page) {
      this.spinner(true)
      if (this.query.page < this.allLocations.total_pages) {
        this.query.page++
        await this.$store.dispatch('locations/GetAllLocations', this.query)
      }
      this.spinner(false)
    },

    openViewLocationDialog (item) {
      this.selectedLocation = item
      this.viewLocationsDialog = true
    },

    resetAll () {
      Object.assign(this.$data, initialState())
      this.$store.commit('locations/SET_LOCATION', '')
      this.$store.commit('locations/SET_LOCATION_ADDRESS', '')
    },

    ...mapActions({
      getAddress: 'locations/GetAddressOfLocation'
    })
  }
}
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
